/* eslint-disable import/no-anonymous-default-export */
import { GOT_SOCKET_ONLINE_USERS } from '../actions/types';

const initialState = [];

export default (state = initialState, action) => {
  switch (action.type) {
    case GOT_SOCKET_ONLINE_USERS:
      return action.payload;
    default:
      return state;
  }
};
